import React from 'react';
import { TFunction } from 'i18next';
import { MorevertIcons } from '../../../../icons/icons';
import { ContextMenuButton, NameEmailAvatar } from '../../../../ui';
import { ADMIN_PAGES_KEYS } from '../../../../i18n/constants/keys';
import { EmployeeUser } from '../../../../utils/types/admin_types';

// Tooltip component for displaying truncated text with a hover tooltip
const TooltipWrapper: React.FC<{ text: string }> = ({ text }) => (
  <div className='relative group inline-block'>
    { /* Truncated Text */ }
    <div className='max-w-[180px] truncate whitespace-nowrap overflow-hidden'>
      { text || '-' }
    </div>
    { /* Tooltip */ }
    <div className='absolute z-[9999] hidden group-hover:flex flex-col items-center'>
      <div className='relative'>
        <div className='absolute bottom-full px-3 py-2 text-sm text-white bg-gray-900 rounded-md shadow-lg w-max max-w-xs whitespace-normal'>
          { text }
        </div>
      </div>
    </div>
  </div>
);

interface GetColumnsArgs {
  handleOpenMenu: (
    e: React.MouseEvent<HTMLButtonElement>,
    row: EmployeeUser
  ) => void;
  handleCloseMenu: () => void;
  anchorEl: HTMLElement | null;
  t: TFunction;
}

export const getColumns = ({
  handleOpenMenu,
  handleCloseMenu,
  anchorEl,
  t,
}: GetColumnsArgs) => {
  const EM = ADMIN_PAGES_KEYS.employeeManagement;
  return [
    {
      key: 'Name',
      label: t(EM.columns.user),
      width: '250px',
      align: 'left' as const,
      render: (row: any) => (
        <NameEmailAvatar
            email={row['user']?.email}
            name={`${row['user']?.firstName} ${row['user']?.lastName}`}
            avatar={row['user']?.avatar}
        />
      ),
      disableSort: true,
    },
    {
      key: 'Groups',
      label: t(EM.columns.groups),
      width: '250px',
      align: 'left' as const,
      render: (row: any) => (
        <TooltipWrapper
            text={row['groups']
              ?.map((group: any) => group.groupName)
              .join(', ')}
        />
      ),
      disableSort: true,
    },
    {
      key: 'Last Active',
      label: t(EM.columns.lastActive),
      width: '250px',
      align: 'left' as const,
      render: (row: any) => (
        <TooltipWrapper
            text={
              row['lastActive']
                ? new Date(row['lastActive'] * 1000).toLocaleString()
                : '-'
            }
        />
      ),
      disableSort: true,
    },
    {
      key: 'Actions',
      label: '',
      width: '100px',
      align: 'right' as const,
      render: (row: EmployeeUser) => (
        <ContextMenuButton
            row={row}
            onOpenMenu={(e, row) => handleOpenMenu(e, row as EmployeeUser)}
            onCloseMenu={handleCloseMenu}
            anchorEl={anchorEl}
        />
      ),
      disableSort: true,
    },
  ];
};
